import {
  PageFooterCentralLink,
  PageFooterCentralLinksHolder,
} from './PageFooterCentralLinks.styled';

const links = [
  {
    title: 'Terms',
    href: '/en/terms-of-service',
    trackClickedName: 'Terms Of Service',
  },
  {
    type: 'privacy-policy',
    title: 'Privacy Policy',
    href: '/en/privacy-policy',
    trackClickedName: 'Privacy Policy',
  },
  {
    title: 'Site Map',
    href: '/en/sitemap',
    trackClickedName: 'Site Map',
  },
];

export function PageFooterCentralLinks() {
  return (
    <PageFooterCentralLinksHolder>
      {links.map((link) => (
        <PageFooterCentralLink
          type="link"
          key={link.title}
          href={link.href}
          trackClicked={{
            name: link.trackClickedName,
            properties: { context: 'Footer' },
          }}
        >
          {link.title}
        </PageFooterCentralLink>
      ))}
    </PageFooterCentralLinksHolder>
  );
}
